(function() {
  'use strict';

  function HistoricoPedidoConfirmacaoCtrl($scope, $stateParams, Historico) {
    // classe para animação da view
    $scope.pageClass = 'page-confirmacao';
    Historico.getSituacaoOsV2($stateParams.idPedido)
      .then(function(status) {
        $scope.mensagemColeta = status.mensagemColeta;
        $scope.mensagemPostagem = null;
      });
  };

  angular
    .module('mandaeApp')
    .controller('HistoricoPedidoConfirmacaoCtrl', HistoricoPedidoConfirmacaoCtrl);

}());
